// extracted by mini-css-extract-plugin
export default {"settings":"Settings_settings__VtLk8","header":"Settings_header__lcb8e"};